import { render, staticRenderFns } from "./deliveryAddress.vue?vue&type=template&id=5b0df04f&scoped=true"
import script from "./deliveryAddress.vue?vue&type=script&lang=js"
export * from "./deliveryAddress.vue?vue&type=script&lang=js"
import style0 from "./deliveryAddress.vue?vue&type=style&index=0&id=5b0df04f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0df04f",
  null
  
)

export default component.exports